import React from 'react';
import { fonts, heights, widths, colors, spacing } from './../../styles/theme.json';

const SingleLineCaption = (props) => {
  const styleWhite = {
    color: '#FFFFFF'
  };
  const styleBlack = {
    color: '#010101'
  };
  return (
    <div className={(props.Stacked) ? 'caption-wrapper column' : 'caption-wrapper row'} style={props.White ? styleWhite : styleBlack}>
      { (props.Headline) ? <span className="primary" dangerouslySetInnerHTML={{__html:props.Headline}} /> : null }
      { (props.Sep && props.Description) ? <span className="separator">/</span> : null }
      { (props.Description) ? <span className="secondary" dangerouslySetInnerHTML={{ __html: props.Description }} /> : null }
      { (props.Date)
        ? <span>
            <span className="sep">{' '}</span>
            <span className="secondary">
              {(props.Description) ? <span dangerouslySetInnerHTML={{ __html: props.Description }} /> : null}
              {(props.DateComma) ? <span>{', '}</span> : null}
              {(props.Date) ? <span dangerouslySetInnerHTML={{ __html: props.Date }} /> : null}
            </span>
          </span>
        : null
      }
      <style jsx>{`
        .caption-wrapper {
          width: 100%;
          margin-bottom: 0;
        }
        .caption-wrapper a {
          font-weight: bold;
        }
        .column {
          flex-direction: column;
        }
        .column > .secondary {
          padding-top: .5rem;
        }
        .row {
          flex-direction: row;
        }
        .row > .secondary {
          padding-left: .5rem;
        }
        .row > .separator {
          padding-left: .5rem;
        }
        .column span {
          display: block;
        }
        .primary a,
        .sep a,
        .secondary a {
          font-weight: bold;
        }
        .separator,
        .primary,
        .sep,
        .secondary {
          font-size: ${fonts.tiny};
          letter-spacing: ${fonts.caption_spacing};
          font-family: ${fonts.mallory};
          text-transform: uppercase;
          margin: 0;
        }        
        .primary,
        .sep {
          font-family: ${fonts.mallory};
          padding-right: .15rem;
          font-weight: bold;
        }
        .secondary {
          font-family: ${fonts.mallory};
          font-weight: normal;
        }
      `}</style>
    </div>
  );
};

export default SingleLineCaption;



// WEBPACK FOOTER //
// ./src/components/dom-elements/SingleLineCaption.js